/**
 * Kleurtabellen voor de kleurstalen in de configurator.
 *
 * - PMS: benaderde sRGB-waarden van Pantone Solid Coated (C). Een scherm kan
 *   een Pantone-kleur nooit exact tonen; dit is een herkenbare staal, geen
 *   proefdruk. 871-876 C zijn metallic goud, 877 C metallic zilver.
 * - RAL: de volledige RAL Classic-reeks (benaderde sRGB).
 * - Namen: nl/en/de/fr plus de kleurnamen die de textielleveranciers gebruiken
 *   (Comfort Colors, Gildan, Bella+Canvas en dergelijke). Sleutels zijn al
 *   genormaliseerd: kleine letters, zonder accenten, ß als ss.
 */

const PMS_SOURCE = `
100:F6EB61 101:F7EA48 102:FCE300 103:C5A900 104:AF9800 105:897A27 106:F9E547 107:FBE122 108:FEDB00 109:FFD100
110:DAAA00 111:AA8A00 112:9C8412 113:FAE053 114:FBDD40 115:FDDA24 116:FFCD00 117:C99700 118:AC8400 119:897322
120:FBD872 121:FDD757 122:FED141 123:FFC72C 124:EAAA00 125:B58500 126:9A7611 127:F3DD6D 128:F3D54E 129:F3D03E
130:F2A900 131:CC8A00 132:A07400 133:6C571B 134:FDD26E 135:FFC658 136:FFBF3F 137:FFA300 138:DE7C00 139:AF6D04
140:74531C 141:F2C75C 142:F1BE48 143:F1B434 144:ED8B00 145:CF7F00 146:A76800 147:715C2A 148:FECB8B 149:FFC27B
150:FFB25B 151:FF8200 152:E57200 153:BE6A14 154:9B5A1A 155:EFD19F 156:EFBE7D 157:ECA154 158:E87722 159:CB6015
160:A1561C 161:603D20 162:FFBE9F 163:FF9D6E 164:FF7F41 165:FF6A13 166:E35205 167:BE531C 168:73381D 169:FFB3AB
170:FF8674 171:FF5C39 172:FA4616 173:CF4520 174:963821 175:6B3529 176:FFB1BB 177:FF808B 178:FF585D 179:E03C31
180:BE3A34 181:7B2E2C 182:FABBCB 183:FC9BB3 184:F65275 185:E4002B 186:C8102E 187:A6192E 188:76232F 189:F8A3BC
190:F67599 191:EF426F 192:E40046 193:BF0D3E 194:9B2743 195:782F40 196:F4C3CC 197:ED9BB0 198:DF4661 199:D50032
200:BA0C2F 201:9D2235 202:862633 203:F2ACB9 204:E8789C 205:E0457B 206:CE0037 207:A50034 208:861F41 209:6F263D
210:F99FC9 211:F57EB6 212:F04E98 213:E3006D 214:CE0069 215:A50050 216:7C2348 217:EABEDB 218:E56DB1 219:DA1884
220:A50050 221:910048 222:6C1D45 223:EF95CF 224:EB6FBD 225:DF1995 226:D0006F 227:AA0061 228:89074F 229:672146
230:F4A6D7 231:F277C6 232:E93CAC 233:C6007E 234:A20067 235:840B55 236:F1A7DC 237:EC86D0 238:E45DBF 239:DB3EB1
240:C5299B 241:AF1685 242:80225F 243:F1B2DC 244:EB9BD2 245:E780C9 246:C724B1 247:BB16A3 248:A51890 249:7F2C7E
250:E7BAE4 251:DD9CDF 252:C964CF 253:AD1AAC 254:981E97 255:72246C 256:D6BFDD 257:C6A1CF 258:8C4799 259:6D2077
260:5E2751 261:51274A 262:4B2D42 263:D7C6E6 264:C1A7E2 265:9063CD 266:753BBD 267:5F259F 268:582C83 269:512D6D
270:B4B5DF 271:9595D2 272:7474C1 273:24135F 274:211551 275:201747 276:221C35 277:ABCAE9 278:8BB8E8 279:418FDE
280:012169 281:00205B 282:041E42 283:9BCBEB 284:6CACE4 285:0072CE 286:0033A0 287:003087 288:002D72 289:0C2340
290:B9D9EB 291:9BCBEB 292:69B3E7 293:003DA5 294:002F6C 295:002855 296:041C2C 297:71C5E8 298:41B6E6 299:00A3E0
300:005EB8 301:004B87 302:003B5C 303:002A3A 304:9ADBE8 305:59CBE8 306:00B5E2 307:006BA6 308:00587C 309:003B49
310:6AD1E3 311:05C3DE 312:00A9CE 313:0092BC 314:007FA3 315:00677F 316:004851 317:B1E4E3 318:88DBDF 319:2DCCD3
320:009CA6 321:008C95 322:007377 323:005F61 324:9CDBD9 325:64CCC9 326:00B2A9 327:008675 328:007367 329:00685E
330:00594F 331:A7E6D7 332:8FE2D0 333:3CDBC0 334:009775 335:007B5F 336:00664F 337:8FD6BD 338:6ECEB2 339:00B388
340:00965E 341:007A53 342:006747 343:115740 344:A0DAB3 345:91D6AC 346:71CC98 347:009A44 348:00843D 349:046A38
350:2C5234 351:A2E4B8 352:8FE2B0 353:80E0A7 354:00B140 355:009639 356:007A33 357:215732 358:ADDC91 359:A1D884
360:6CC24A 361:43B02A 362:509E2F 363:4C8C2B 364:4A7729 365:C2E189 366:B7DD79 367:A4D65E 368:78BE20 369:64A70B
370:658D1B 371:546223 372:D4EB8E 373:CDEA80 374:C5E86C 375:97D700 376:84BD00 377:7A9A01 378:59621D 379:E2E868
380:DBE442 381:CEDC00 382:C4D600 383:A8AD00 384:949300 385:787121 386:E9EC6B 387:E3E935 388:E0E721 389:D0DF00
390:B5BD00 391:9A9500 392:827A04 393:F0EC74 394:EDE939 395:ECE81A 396:E1E000 397:BFB800 398:ADA400 399:A09200
400:C4BFB6 401:AFA96E 402:A39382 403:8E7F6E 404:776B5E 405:6A5E50 406:C4BCB7 407:B2A8A2 408:968C83 409:8C8279
410:7A6E66 411:5E514D 412:382E2C 413:BABBB1 414:A8A99E 415:919388 416:7E7F74 417:65665C 418:51534A 419:212322
420:C7C9C7 421:B2B4B2 422:9EA2A2 423:898D8D 424:707372 425:54585A 426:25282A 427:D0D3D4 428:C1C6C8 429:A2AAAD
430:7C878E 431:5B6770 432:333F48 433:1D252D 434:D7C4B7 435:C9B1A9 436:B7A099 437:7B6469 438:584446 439:453536
440:382F2D 441:BEC6C4 442:A2ACAB 443:919D9D 444:717C7D 445:505759 446:3F4444 447:373A36 448:4A412A 449:524727
450:594A25 451:9B945F 452:B0AA7E 453:BFBB98 454:CAC7A7 455:8A7A28 456:9E8A4A 457:B5975A 458:DCC48B 459:E1C99C
460:EADCA5 461:EEDEB1 462:5C462B 463:744F28 464:8B5B29 465:B9975B 466:C6AA76 467:D3BC8D 468:DDCBA4 469:693F23
470:A45A2A 471:B86125 472:E59E6D 473:F1C6A7 474:F2C6A8 475:F3CFB3 476:4E3629 477:623B2A 478:703F2A 479:A67F6F
480:D3BBA8 481:E0C8B9 482:E5CEC0 483:6B3529 484:9A3324 485:DA291C 486:E8927C 487:EAA794 488:ECB3A2 489:F2C6B8
490:5D2A2C 491:6F2C2C 492:782F2C 493:DB8A93 494:F2ACB9 495:F4BAC6 496:F7C6CF 497:512F2E 498:5A332F 499:7A3E3A
500:CE8E99 501:EAB7C3 502:F2C6CF 503:F4D4D9 504:51262A 505:66282E 506:7B2D3A 507:D8A0B0 508:E8B8C9 509:F2C8D6
510:F4D2DE 511:60244E 512:84206F 513:9E3A8F 514:D88EC6 515:E8AED8 516:F0C3E0 517:F4D2E5 518:4E2944 519:5D2D58
520:6E3772 521:A57FB2 522:C6A3D4 523:D3B7E2 524:E3CBEB 525:512A44 526:68217A 527:8031A7 528:AD96DC 529:CEB1E0
530:D5C0E6 531:E0D1EB 532:263147 533:1F2A44 534:1B365D 535:A7B7CA 536:B4C3D4 537:C4D0DE 538:D3DDE6 539:002F4A
540:003A5D 541:003C71 542:7BAFD4 543:9BC0DE 544:B0CBE3 545:C6DAE7 546:002F38 547:003F48 548:004859 549:6BA4B8
550:87AFBF 551:A2C0CC 552:B9D3DC 553:2C4F43 554:285C4D 555:2F6F5A 556:6FA287 557:85B09A 558:A3C3B3 559:BBD2C4
560:2B4C3F 561:285C4D 562:006F62 563:6BBBAE 564:86C8BC 565:A0D5CA 566:B9DCD2 567:173F35 568:00715F 569:00816D
570:6BCAB0 571:8BD3BE 572:A3DECC 573:B8E5D5 574:4A5E26 575:546223 576:5C7F3A 577:A4B983 578:B0C38E 579:BDCC9C
580:CBD8AD 581:5E5A1A 582:7E7E0F 583:B7BF10 584:D2D755 585:DCE07B 586:E2E58E 587:E7E9A6
600:F1EB9C 601:F0E991 602:F0E87B 603:EDE04B 604:EADA24 605:E1CD00 606:CFB500 607:EBE49A 608:E9E186 609:E6DE77
610:E1D555 611:D7C826 612:C4B000 613:B39B00 614:DCD59A 615:D6CF8D 616:D0C883 617:C0B561 618:AC9F3C 619:9F912A
620:8A7B19 621:CFE0DC 622:B7CDC2 623:9AB9AD 624:789F90 625:507F70 626:285C4D 627:13322B 628:CCE7EE 629:A5DFEB
630:8CD5E5 631:3AC5DB 632:00A0BE 633:007DA4 634:00648B 635:B5DFE7 636:9ED7E6 637:66C6DE 638:00AFD7 639:009AC7
640:0083B3 641:006BA6 642:D1DDE6 643:C6D6E3 644:9BB8D3 645:7DA1C4 646:5E8AB4 647:236192 648:002E5D 649:DBE2E9
650:CED9E5 651:A7BCD6 652:7D9BC1 653:326295 654:003A70 655:002554 656:DDE5ED 657:C8D8EB 658:B1C9E8 659:7BA4DB
660:407EC9 661:003594 662:001A70 663:E5E1E6 664:E0DBE3 665:C6BCD0 666:A192B2 667:7C6992 668:614B79 669:3F2A56
670:F2D6E7 671:EFBAE1 672:E277CD 673:E5A2D3 674:D3509D 675:BE2A82 676:A5006E 677:E5CEDB 678:E3C8D8 679:DDBCD3
680:B784A7 681:94557E 682:8C4973 683:7F2D63 684:EFCDDC 685:EBC0D6 686:E3AFC9 687:C77DA5 688:B6598C 689:893B67
690:612141 691:EED3D7 692:E8C1C8 693:DBA6B3 694:C98D9F 695:B47786 696:8E4C5A 697:7B3E4C 698:F2D4D7 699:F4C2C9
700:F2A9B6 701:EA8B9D 702:D86B80 703:B83A4B 704:9E2A2B 705:F5DADF 706:F7CED7 707:F9B5C4 708:F890A5 709:EF6079
710:E03E52 711:CB2C30 712:FFD3AA 713:F9C898 714:FBBD82 715:F79E58 716:F48024 717:D5652A 718:BE5B1F 719:EDC8A3
720:E7B78A 721:DDA36C 722:B47D4E 723:A0633A 724:7F4019 725:6E3814 726:EDD3BC 727:E2BFA3 728:D3A27E 729:B37E58
730:9A6A44 731:723F1C 732:5E3418
801:009ACE 802:44D62C 803:FFE900 804:FFAA4D 805:FF7276 806:FF3EB5 807:EA27C2
7401:F5E1A4 7402:ECD898 7403:EED484 7404:F4DA40 7405:F2CD00 7406:F1C400 7407:CBA052 7408:F6BE00 7409:F0B323
7410:FEAD77 7411:E6A65D 7412:D38235 7413:DC8633 7414:C16C18 7415:F6CFB6 7416:E5554F 7417:E04E39 7418:CD545B
7419:B04A5A 7420:9B2242 7421:651D32 7422:FAE0E6 7423:E06287 7424:E24585 7425:B52555 7426:A4123F 7427:97233F
7428:6A2C3E 7429:D8C8D1 7430:D3A6C2 7431:B57099 7432:A74F7E 7433:A4385F 7434:A12F59 7435:830065 7436:EEDAEA
7437:CCAED0 7438:D59ED7 7439:B18EB5 7440:A17FAD 7441:9E6EB8 7442:7841A3 7443:DDDAE8 7444:B6B8DC 7445:A7A4E0
7446:8B84D7 7447:5C4E8E 7448:4B384C 7449:410F2E 7450:BDC5DB 7451:89ABE3 7452:8094DD 7453:7BA4DB 7454:6F8FAF
7455:3A5DAE 7456:6475BC 7457:BBE7E6 7458:71B2C9 7459:4298B5 7460:0086BF 7461:007DBA 7462:00558C 7463:002B49
7464:A0D1CA 7465:40C1AC 7466:00B0B9 7467:00A3AD 7468:007398 7469:005F86 7470:005A70 7471:7EDDD3 7472:5CB8B2
7473:279989 7474:007481 7475:487A7B 7476:0D5257 7477:244C5A 7478:9BE3BF 7479:26D07C 7480:00BF6F 7481:00B74F
7482:009F4D 7483:275D38 7484:00573F 7485:D0E6C4 7486:BBE89E 7487:8DE680 7488:78D64B 7489:74AA50 7490:719949
7491:79863C 7492:C0D48D 7493:BACEA0 7494:9CAF88 7495:8F993E 7496:76881D 7497:7A7256 7498:5B6236 7499:F1E6B2
7500:DFD1A7 7501:D9C89E 7502:CEB888 7503:A89968 7504:94795D 7505:816040 7506:EFDBB2 7507:FCD299 7508:E1B87F
7509:D6A461 7510:C6893F 7511:B77729 7512:A6631B 7513:E3B5A0 7514:D69A7D 7515:C1846A 7516:A45B3D 7517:8C4A28
7518:6D4F47 7519:5E4B3C 7520:EAB8A7 7521:C09C83 7522:B4645C 7523:A9594E 7524:A65244 7525:A0715C 7526:8A391B
7527:D6D2C4 7528:C5BFB4 7529:B7A99A 7530:A39382 7531:7A6855 7532:65524A 7533:4B3B2F 7534:D1CCBD 7535:B7B09C
7536:A69F88 7537:A7ACA2 7538:949A91 7539:8E9089 7540:4B4F54 7541:D9E1E2 7542:A4BCC2 7543:98A4AE 7544:768692
7545:425563 7546:253746 7547:131E29 7548:FFC600 7549:FFB500 7550:D19000 7551:B47E00 7552:73532B 7553:5A4522
7554:4B3D2A 7555:D29F13 7556:B78B20 7557:9F8A43 7558:948652 7559:8A7A3D
7576:DB864E 7577:E07E3C 7578:DC6B2F 7579:DC582A 7580:C05131 7581:864A33 7582:674736 7583:C4622D 7584:BA5826
7585:AF5C37 7586:9E5330 7587:924C2E 7588:7B4D35 7589:5C4738 7590:D4B59E 7591:C07D59 7592:B15533 7593:9D4223
7594:7C3A2D 7595:6B3D2E 7596:5C3D31 7597:D14124 7598:BD472A 7599:B33D26 7600:8D3F2B 7601:83412C 7602:7B4931
7603:674230 7604:E4D5D3 7605:E1BBB4 7606:D6938A 7607:C26E60 7608:A4493D 7609:823B34 7610:683431 7611:DDBCB0
7612:CA9A8E 7613:BC8A7E 7614:A37F74 7615:866761 7616:6B4C4C 7617:583D3E 7618:C66E4E 7619:C04C36 7620:B7312C
7621:AB2328 7622:93272C 7623:8A2A2B 7624:802F2D 7625:E1523D 7626:C63527 7627:A72B2A 7628:9A3A33 7629:5C3D39
7630:4B3536 7631:572D2D 7632:D6C9CA 7633:C4A4A7 7634:C16784 7635:C0485E 7636:BC204B 7637:912F46 7638:7E2D40
7639:9B6476 7640:8E2C48 7641:893B67 7642:5E2751 7643:5D3754 7644:5D3754 7645:9B5F9B 7646:9B6489 7647:A83D72
7648:8B2C6E 7649:8A1B61 7650:722257 7651:B48A9B 7652:9B6D85 7653:976A7F 7654:A2789C 7655:A05EB5 7656:8A2AA0
7657:6C1D6B 7658:6A3460 7659:5D3754 7660:9991A4 7661:8D6E97 7662:7A4183 7663:6B3077 7664:653279 7665:5E366E
7666:5C4E63 7667:6E7CA0 7668:686E9F 7669:615E9B 7670:565294 7671:514689 7672:4C4184 7673:4F4A84 7674:878CB4
7675:7C7FAB 7676:7566A0 7677:6F5091 7678:68478D 7679:563D82 7680:523178 7681:94A9CB 7682:6787B7 7683:426DA9
7684:385E9D 7685:2C5697 7686:1D4F91 7687:1D428A 7688:4698CB 7689:298FC2 7690:0076A8 7691:006298 7692:005487
7693:004A80 7694:003F6D 7695:7BA7BC 7696:6399AE 7697:4E87A0 7698:41748D 7699:34657F 7700:165C7D 7701:005776
7702:48A9C5 7703:009CBD 7704:0085AD 7705:00728F 7706:006A8E 7707:00657F 7708:005670 7709:63B1BC 7710:00A7B5
7711:0097A9 7712:00859B 7713:007681 7714:006D75 7715:005961 7716:00857D 7717:007C70 7718:007069 7719:006A60
7720:005E5D 7721:005151 7722:004E42 7723:50A684 7724:00965E 7725:008755 7726:007B4B 7727:006F44 7728:00663F
7729:005D3D 7730:4B9560 7731:228848 7732:007A3E 7733:007041 7734:286140 7735:36573B 7736:395542 7737:6BA539
7738:48A23F 7739:319B42 7740:3A913F 7741:44883E 7742:4A7729 7743:44693D 7744:BABC16 7745:ABAD23 7746:999B30
7747:888D30 7748:7C8034 7749:727733 7750:C5B783 7751:CAB64B 7752:CFB023 7753:C1A01E 7754:A08629 7755:897630
7756:6C6331 7757:D4C304 7758:C4B200 7759:AE9B00 7760:8E8C13 7761:76762E 7762:5D6439 7763:5D5F2A 7764:7D7F35
7765:9A9D34 7766:B5B54C 7767:A99F33 7768:A2A44F 7769:9B8E00 7770:8A7B19 7771:6E6526
871:84754E 872:85714D 873:866D4B 874:8B6F4E 875:87674F 876:8B634B 877:8A8D8F
`;

/** Pantone-namen ("Reflex Blue C", "Cool Gray 7 C") naar hex. */
export const PMS_NAMED: Record<string, string> = {
  yellow: '#FEDD00',
  'yellow 012': '#FFD700',
  'orange 021': '#FE5000',
  'warm red': '#F9423A',
  'red 032': '#EF3340',
  'rubine red': '#CE0058',
  'rhodamine red': '#E10098',
  purple: '#BB29BB',
  violet: '#440099',
  'blue 072': '#10069F',
  'reflex blue': '#001489',
  'process blue': '#0085CA',
  'process cyan': '#00AEEF',
  'process magenta': '#EC008C',
  'process yellow': '#FFED00',
  'process black': '#2D2926',
  green: '#00AB84',
  black: '#2D2926',
  'black 6': '#101820',
  'black 7': '#3D3935',
  'cool gray 1': '#D9D9D6',
  'cool gray 2': '#D0D0CE',
  'cool gray 3': '#C8C9C7',
  'cool gray 4': '#BBBCBC',
  'cool gray 5': '#B1B3B3',
  'cool gray 6': '#A7A8AA',
  'cool gray 7': '#97999B',
  'cool gray 8': '#888B8D',
  'cool gray 9': '#75787B',
  'cool gray 10': '#63666A',
  'cool gray 11': '#53565A',
  'warm gray 1': '#D7D2CB',
  'warm gray 2': '#CBC4BC',
  'warm gray 3': '#BFB8AF',
  'warm gray 4': '#B6ADA5',
  'warm gray 5': '#ACA39A',
  'warm gray 6': '#A59C94',
  'warm gray 7': '#968C83',
  'warm gray 8': '#8C8279',
  'warm gray 9': '#83786F',
  'warm gray 10': '#796E65',
  'warm gray 11': '#6E6259',
};

/** Pantone-nummers die metallic zijn: goud (871-876, 8003 e.d.) of zilver (877). */
export const PMS_METALLIC_GOLD = new Set(['871', '872', '873', '874', '875', '876', '10122', '10124']);
export const PMS_METALLIC_SILVER = new Set(['877', '8001', '10077', '10103']);

const RAL_SOURCE = `
1000:BEBD7F 1001:C2B078 1002:C6A664 1003:E5BE01 1004:CDA434 1005:A98307 1006:E4A010 1007:DC9D00 1011:8A6642
1012:C7B446 1013:EAE6CA 1014:E1CC4F 1015:E6D690 1016:EDFF21 1017:F5D033 1018:F8F32B 1019:9E9764 1020:999950
1021:F3DA0B 1023:FAD201 1024:AEA04B 1026:FFFF00 1027:9D9101 1028:F4A900 1032:D6AE01 1033:F3A505 1034:EFA94A
1035:6A5D4D 1036:705335 1037:F39F18
2000:ED760E 2001:C93C20 2002:CB2821 2003:FF7514 2004:F44611 2005:FF2301 2007:FFA420 2008:F75E25 2009:F54021
2010:D84B20 2011:EC7C26 2012:E55137 2013:C35831
3000:AF2B1E 3001:A52019 3002:A2231D 3003:9B111E 3004:75151E 3005:5E2129 3007:412227 3009:642424 3011:781F19
3012:C1876B 3013:A12312 3014:D36E70 3015:EA899A 3016:B32821 3017:E63244 3018:D53032 3020:CC0605 3022:D95030
3024:F80000 3026:FE0000 3027:C51D34 3028:CB3234 3031:B32428 3032:721422 3033:B44C43
4001:6D3F5B 4002:922B3E 4003:DE4C8A 4004:641C34 4005:6C4675 4006:A03472 4007:4A192C 4008:924E7D 4009:A18594
4010:CF3476 4011:8673A1 4012:6C6874
5000:354D73 5001:1F3438 5002:20214F 5003:1D1E33 5004:18171C 5005:1E2460 5007:3E5F8A 5008:26252D 5009:025669
5010:0E294B 5011:231A24 5012:3B83BD 5013:1E213D 5014:606E8C 5015:2271B3 5017:063971 5018:3F888F 5019:1B5583
5020:1D334A 5021:256D7B 5022:252850 5023:49678D 5024:5D9B9B 5025:2A6478 5026:102C54
6000:316650 6001:287233 6002:2D572C 6003:424632 6004:1F3A3D 6005:2F4538 6006:3E3B32 6007:343B29 6008:39352A
6009:31372B 6010:35682D 6011:587246 6012:343E40 6013:6C7156 6014:47402E 6015:3B3C36 6016:1E5945 6017:4C9141
6018:57A639 6019:BDECB6 6020:2E3A23 6021:89AC76 6022:25221B 6024:308446 6025:3D642D 6026:015D52 6027:84C3BE
6028:2C5545 6029:20603D 6032:317F43 6033:497E76 6034:7FB5B5 6035:1C542D 6036:193737 6037:008F39 6038:00BB2D
7000:78858B 7001:8A9597 7002:7E7B52 7003:6C7059 7004:969992 7005:646B63 7006:6D6552 7008:6A5F31 7009:4D5645
7010:4C514A 7011:434B4D 7012:4E5754 7013:464531 7015:434750 7016:293133 7021:23282B 7022:332F2C 7023:686C5E
7024:474A51 7026:2F353B 7030:8B8C7A 7031:474B4E 7032:B8B799 7033:7D8471 7034:8F8B66 7035:D7D7D7 7036:7F7679
7037:7D7F7D 7038:B5B8B1 7039:6C6960 7040:9DA1AA 7042:8D948D 7043:4E5452 7044:CAC4B0 7045:909090 7046:82898F
7047:D0D0D0 7048:898176
8000:826C34 8001:955F20 8002:6C3B2A 8003:734222 8004:8E402A 8007:59351F 8008:6F4F28 8011:5B3A29 8012:592321
8014:382C1E 8015:633A34 8016:4C2F27 8017:45322E 8019:403A3A 8022:212121 8023:A65E2E 8024:79553D 8025:755C48
8028:4E3B31 8029:763C28
9001:FDF4E3 9002:E7EBDA 9003:F4F4F4 9004:282828 9005:0A0A0A 9006:A5A5A5 9007:8F8F8F 9010:FFFFFF 9011:1C1C1C
9016:F6F6F6 9017:1E1E1E 9018:D7D7D7 9022:9C9C9C 9023:828282
`;

/** RAL-tinten met een metallic/parelglans: die krijgen een glansverloop. */
export const RAL_METALLIC = new Set(['1035', '1036', '2013', '3032', '3033', '4011', '4012', '5025', '5026', '6035', '6036', '7048', '8029', '9006', '9007', '9022', '9023']);

function parseCodeTable(source: string): Record<string, string> {
  const table: Record<string, string> = {};
  for (const entry of source.split(/\s+/)) {
    if (!entry) continue;
    const [code, hex] = entry.split(':');
    if (code && hex) table[code] = `#${hex.toUpperCase()}`;
  }
  return table;
}

export const PMS_COATED: Record<string, string> = parseCodeTable(PMS_SOURCE);
export const RAL_CLASSIC: Record<string, string> = parseCodeTable(RAL_SOURCE);

/**
 * Kleurnamen per hex. Elke regel: hex, daarna synoniemen gescheiden door "|".
 * Volgorde binnen een regel maakt niet uit; dubbele sleutels: de eerste wint.
 */
const NAME_SOURCE = `
#FFFFFF white|wit|witte|weiss|weisse|weisses|weisser|blanc|blanche|bianco|blanco|branco|ultra white|ultrawhite|ultraweiss|extra white|bright white|pure white|solid white|snow|sneeuwwit|schneeweiss|optical white|helder wit|klaresweiss|blanc brillant|fil blanc|wit garen|weisses garn|white thread
#F5F1E6 off white|offwhite|gebroken wit|blanc casse|egret|egret off white|egret offwhite|blanc casse aigrette|natural white|naturwit
#F7F5EE soft white|weichweiss|blanc doux|zachtwit
#F4EFE4 vintage white|vintage weiss|blanc vintage
#E8DFCF faded bone|verblasstes knochenweiss|blanc os delave|bone|knochen
#F6EFD9 cream white|cremewit|roomwit|cremeweiss|blanc creme|wollweiss
#F3EAD7 cream|creme|crema|creme doux|soft cream|zachte creme
#F6F0DC ivory|ivoor|ivoire|elfenbein|elfenbeinfarbe|avorio
#E3DAC5 ecru|ecru wit
#E8DCC2 natural|naturel|natur|natuur|naturlich|organic natural|organisch naturel|bio natur|naturel bio|natural raw|naturroh|naturel brut|nature melange|naturmeliert|natural stone|naturstein|pierre naturelle
#111111 black|zwart|zwarte|schwarz|schwarze|schwarzes|schwarzer|noir|noire|nero|negro|preto|black pure|schwarz pur|noir pur|jet black|deep black|tiefschwarz|black licorice|schwarze lakritze|fil noir|zwart garen|schwarzes garn|black thread
#9CA3AF grey|gray|grijs|grijze|grau|graue|grauer|gris|grise|grigio|cinza|pure grey|reingrau|gris pur|gemeleerd grijs|grey melange|grau meliert|graumeliert|gris chine|grijs melange
#D1D5DB light grey|light gray|lichtgrijs|hellgrau|helles grau|gris clair|pale grey|blassgrau
#D5D8DA ice grey|ice gray|eisgrau|ijsgrijs|gris glace|gris glacier|cloud grey|wolkengrijs
#CBCDCF powder grey|pudergrau|gris poudre
#D3D3CF ash|ash grey|ash gray|aschgrau|asche|cendre|gris cendre|eschegrau|essengrijs|gris frene
#A5A7A8 sport grey|sport gray|sportgrau|sport grau|sport grijs|gris sport|sportliches graumeliert|athletic heather|athletic grey
#B5B5B5 heather grey|heather gray|heather grijs|heather grau|light grey melange|hellgrau meliert|gris chine clair|heather light grey|heather lichtgrijs|grey heather
#9A9A9A mid heather grey|mittelgrau meliert|meliertes mittelgrau|gris chine moyen|mid grey|middengrijs|mittelgrau|gris moyen
#9EA2A8 cool grey|cool gray|cool heather grey|kuhles grau|gris froid|gris chine froid|cool grau meliert
#4B5563 dark grey|dark gray|donkergrijs|donker grijs|dunkelgrau|gris fonce|deep grey|tiefgrau|gris profond|donkergijs|dark gey
#36454F charcoal|houtskool|holzkohle|charbon|charcoal grey|charcoal heather|charcoal melange|washed charcoal
#383E42 anthracite|antraciet|anthrazit|anthrazitgrau|gris anthracite|anthracite melange|anthrazit melange|anthrazit meliert|antraciet melange|anthractice
#474A51 graphite|grafiet|graphit|graphitgrau|grafietgrijs|grafiet grijs|graphite grey|grey graphite|grau graphit|gris graphite|grijs grafiet|graphite heather|graphit heather|graphit meliert
#4F5052 asphalt|asfalt|asphalte|asphaltgrau|asphalt grau|asphalt meliert|heather asphalt|bitume
#4A4A4F dark heather|dunkles heather|dark heather grey|dunkel meliert|gris chine fonce|dunkelgrau meliert
#71797E steel grey|steel gray|staalgrijs|stahlgrau|gris acier|slate|leisteen|schiefer|ardoise
#8D8B88 granite|graniet|granit
#5C5B57 pepper|peper|pfeffer|poivre
#4F4F4F tarmac|heather tarmac|tarmac meliert|tarmac chine
#737373 smoke|rook|rauch|fumee|gris fumee
#656A72 storm|sturm|orage
#9A9A93 concrete grey|betongrijs|betongrau|gris beton
#A6A49B cement|zement|ciment|gris ciment
#8A8578 mouse grey|muisgrijs|mausgrau|gris souris
#8E8A86 elephant grey|olifantgrijs|elefantengrau|gris elephant
#7F7F7A convoy grey|konvoi grau|gris convoi
#4B4F54 india ink grey|india ink grau|indiagrau|gris encre de chine|encre de chine grise|india ink
#A8A9AD silver grey|zilvergrijs|zilver grijs|silbergrau|gris argente
#8B7F70 grey brown|grijsbruin|graubraun|brun gris|braungrau
#7E8B76 grey green|grijsgroen|graugrun|gris vert
#6E8297 grey blue|grijsblauw|grijs blauw|graublau|gris bleu
#B8BDC1 zinc|zink
#B5ADA0 stone|steen|stein|pierre
#6E6E6A flint stone|feuerstein|gris silex|flint
#B3B6B7 drizzle grey|nieselgrau|gris bruine
#C3C6C8 fog|mist|nebel|brume|grey fog|grauer nebel|gris brume|heather grey fog
#C0C0C0 silver|zilver|silber|argent|argente|argento|prata|zilverkleurig|silberfarben|silver coloured|aluminium|aluminum|alu|alimunium|aluminium silber|aluminium argent|zilver aluminium|silver aluminium|inox|rvs|stainless steel|edelstahl|edelstahl rostfrei|roestvrij staal|chrome|chroom|chrom|metal|metaal|metall|metale|nickel|nikkel|matt silver|mat zilver|silber matt|argent mat|platinum|platina|platin|platine
#D4AF37 gold|goud|or|dore|oro|ouro|goudkleurig|goldfarben|gold coloured|old gold|altgold|vieux or|oud goud
#C5B358 vegas gold|or vegas
#EAAA00 team gold
#E0A526 honey gold|honiggold|or miel|honinggoud
#F2B705 golden yellow|goudgeel|goldgelb|jaune or
#DAA520 goldenrod|solidago
#E0A899 rose gold|rosegold|rosegoud|or rose|rotgold
#B87333 copper|koper|kupfer|cuivre|rame
#CD7F32 bronze|brons|bronzo
#DC2626 red|rood|rode|rot|rote|roter|rotes|rouge|rosso|rojo|vermelho|true red|echt rood|red 2|rot 2|rouge 2
#E3121B bright red|knalrood|helderrood|leuchtendes rot|rouge vif|rouge eclatant|hellrot
#E1251B fire red|vuurrood|feuerrot|rouge feu
#C8102E classic red|klassiek rood|klassisches rot|rouge classique|team red
#B3000C christmas red|kerstrood|weihnachtsrot|rouge noel
#B11226 cherry red|kersrood|kirschrot|rouge cerise|cherry|kers|kirsche|cerise
#8E1F2F antique cherry red|antikes kirschrot|antik kirschrot|rouge cerise antique
#D2004F bright cherry|helder kersen|helles kirschrot|cerise eclatant
#6E1A2B dark cherry|dunkle kirsche|cerise noire|donkere kers
#A6192E wild cherry|wildkirsche|cerise sauvage
#8C1D2E cardinal|cardinal red|kardinaal|kardinal|kardinalrot|rouge cardinal|kardinaalrood
#B0353F crimson|karmozijn|karmesin|karmesinrot|cramoisi
#8B0000 dark red|donkerrood|donker rood|dunkelrot|rouge fonce|deep red|tiefrot|rouge profond|dieprood
#722F37 wine|wijn|wein|vin|wine red|wijnrood|weinrot|rouge vin|lie de vin
#7C1E2E bordeaux|bordeauxrood|bordeauxrot|rouge bordeaux|burgundy|burgund|burgunderrot|bourgogne|bordo|port royale|port royal|bordeaux port royal|heather burgundy|burgunderrot meliert|bordeaux chine
#5C1F2B maroon|marron rouge|washed maroon|gewaschen maroon
#733635 garnet|granaat|granat|grenat|rouge grenat
#A53F2B brick|brick red|baksteen|baksteenrood|ziegel|ziegelrot|brique|rouge brique
#F1574B coral red|koraalrood|korallrot|rouge corail|rouge coral
#C41E3A lipstick red|lippenstiftrood|lippenrot|rouge a levres|rouge rouge a levres|lipstick
#D52B1E rocket red|rouge rocket
#A02128 signal red|signaalrood|signalrot|rouge signal
#FF3B3F day glow red|day glow rot|rouge day glow
#9E4A3A red earth|roterde|terre rouge
#A0451F rust|roest|rost|rouille
#8B3A1E rust brown|roestbruin|rostbraun|brun rouille
#B5502A orange rust|oranger rost|rouille orangee
#C0412D paprika
#80461B russet|rotbraun|roodbruin|red brown|brun rouge|brun roux|rossbraun
#D8556B watermelon|watermeloen|wassermelone|pasteque
#B5285E raspberry|framboos|himbeere|framboise|heather raspberry|chine framboise
#8C3B5A berry|bes|beere|baie|bessen
#D8507B crunchberry|baie croquante
#C42E6E razzle berry|razzle berry pink
#8F1D35 cranberry|cranberrie|airelle
#F97316 orange|oranje|orangje|arancione|naranja|laranja|pure orange|reines orange|orange pur
#FF6A13 bright orange|knaloranje|helder oranje|leuchtendes orange|orange vif|orange eclatant
#E8590C deep orange|diep oranje|tieforange|orange profond
#D9480F dark orange|donker oranje|donkeroranje|dunkelorange|orange fonce
#F07D1E pumpkin|pompoen|kurbis|citrouille
#F28C28 tangerine|mandarine|mandarijn|tangy tangerine|mandarine acidulee
#BF5700 texas orange|orange texas|t orange
#FF6F00 safety orange|veiligheidsoranje|sicherheitsorange|orange de securite
#F25A1D signal orange|signaal oranje|signaaloranje|signalorange|orange signal
#FF5F1F neon orange|neonoranje|neon oranje|fluo orange|fluo oranje|fluorescent orange|orange fluo|orange fluorescent|orange neon|neonorange|fluoreszierendes orange|day glow orange|orange day glow
#F6905B melon|meloen|melone|melonenorange|melon orange|orange melon
#F6B99A peach|perzik|pfirsich|peche
#F7A986 fresh peach|frischer pfirsich|peche fraiche|fraiche peche
#F2B5A0 peach blush|peche blush|pfirsich rose
#F8B878 apricot|abrikoos|aprikose|abricot
#CF6D45 yam|igname
#C35A3A terracotta|terrakotta|terre cuite
#BD6A4A adobe
#F28C78 salmon|zalm|lachs|saumon
#F49A8C salmon pink|zalmroze|lachsrosa|rose saumon
#F87060 coral|koraal|koralle|corail|amalfi coral|amalfi koralle|corail amalfi|tahiti coral|tahiti koralle|corail tahiti|pixel coral|pixel koralle|corail pixel
#F26B3A sunset|zonsondergang|sonnenuntergang|coucher de soleil|abendrot|avondrood|evening red|rouge soir
#D9622B antique orange|antiek oranje|antik orange|orange antique
#E46B2E urban orange|orange urbain
#FF7A1A vibrant orange|lebendiges orange|orange vibrant
#F58A3A orange fizz
#E0482F fiesta
#FACC15 yellow|geel|gele|gelb|gelbe|gelber|jaune|giallo|amarillo|amarelo
#FFE600 bright yellow|knalgeel|knallgelb|jaune vif|helder geel|leuchtendes gelb
#FCEB8E light yellow|lichtgeel|hellgelb|jaune clair
#F8EDA1 pale yellow|bleekgeel|blassgelb|jaune pale
#F6EA8C pastel yellow|pastelgeel|pastellgelb|jaune pastel|pastel lemon|citron pastel|sanftes gelb|jaune doux|soft yellow
#F7E733 lemon|citroen|zitrone|citron|lemon drop|zitronengelb|jaune citron|citroengeel|wild lemon|zitronenbonbon
#FFC72C sun yellow|sonnengelb|zonnegeel|zon geel|jaune solaire|solar yellow
#FFC512 sunflower|sonnenblume|zonnebloem|tournesol|sunflower yellow|sonnenblumengelb|zonnebloem geel|jaune tournesol
#FCD846 daisy|madeliefje|ganseblumchen|marguerite
#D4A017 mustard|mosterd|senf|moutarde|mustard triblend|senf triblend|triblend moutarde
#CC9933 ochre|oker|ocker|ocre|ochre yellow|okergeel|ockergelb|jaune ocre
#F3E3A0 butter|boter|butter gelb|beurre|jaune beurre|beurre de lait
#EFE5A8 cornsilk|soie de mais|maisgelb|maisgeel
#F9A800 signal yellow|signaal geel|signaalgeel|signalgelb|jaune signal
#DFFF11 neon yellow|neongeel|neon geel|neongelb|fluo yellow|fluo geel|jaune fluo|fluorescent yellow|jaune fluorescent|jaune neon|fluoreszierendes gelb|flurozierendes gelb|day glow yellow
#F2DE1E brimstone|zwavelgeel|schwefelgelb|jaune soufre|brimstone yellow
#F6D743 spectra yellow|spectra gelb|jaune spectra
#F8DE7E mellow yellow
#F2E08C yellow haze|gelber dunst|brume jaune
#FFE135 pop yellow|jaune pop
#F7E05E yellow fizz|gelber sprudel|jaune petillant
#E8D5B0 champagne|champagner|champagnekleur
#16A34A green|groen|groene|grun|grune|grunes|gruner|vert|verte|verde|pure green|vert pur
#8BD17C light green|lichtgroen|hellgrun|vert clair|licht groen
#0F5132 dark green|donkergroen|donker groen|dunkelgrun|vert fonce|darkgreen|darak green|heather dark green|dunkelgrun meliert|vert fonce chine
#2E8B57 mid green|middengroen|mittelgrun|vert moyen
#0B4D2C deep green|tiefgrun|vert profond|diepgroen
#006A4E bottle green|bottlegreen|flessengroen|flessen groen|flaschengrun|flasche grun|flaschegrun|vert bouteille|verte bouteille
#22492F forest|forest green|bosgroen|waldgrun|vert foret|foret|heather forest|chine foret
#1C3A2A dark forest|dunkelwald|vert foret fonce
#00A550 kelly|kelly green|kelly groen|kellygrun|vert kelly|heather kelly|chine kelly
#009E60 irish green|iers groen|irischgrun|irisches grun|vert irlandais
#00754A antique irish green|antik irischgrun|vert irlandais antique
#009B77 emerald|smaragd|emeraude|smaragdgrun|emerald triblend|smaragd triblend|triblend emeraude
#98E2C6 mint|munt|minze|menthe|mint green|mintgroen|mintgrun|minzgrun|vert menthe|heather mint|chine menthe
#B8E8D0 pastel mint|pastellminze|menthe pastel|zarte minze
#9FD8C3 chalky mint|menthe crayeuse
#AEF0D1 neo mint|neomint|neo menthe
#B3DCC9 millennial mint|millennial minze|menthe millenial|menthe millennial
#9CAF88 sage|salie|salbei|sauge|vert sauge|saliegroen
#556B2F olive|olijf|oliv|olive green|olijfgroen|olivgrun|olivegrun|vert olive|oliva
#3F4A22 dark olive|donker olijfgroen|dunkeloliv|dunkles oliv|olive foncee|olive fonce
#6A6B3A classic olive|classic olijf|klassisches oliv|olive classique
#7F7C55 faded olive|verblasstes olivgrun|olive delavee
#C3B091 khaki|kaki|caki|kakhi|faded khaki|verblasstes khaki|kaki delave
#D4C9A8 light khaki|licht khaki|hellkhaki|kaki clair
#8F8763 urban khaki|millennial khaki|kaki urbain|kaki millenial|millennial khaki
#4B5320 military green|militair groen|militargrun|vert militaire|army|army green|armeegrun|vert armee|legergroen|armee|heather military green|military green meliert|vert kaki|gris militaire
#4B5D3A camo|camouflage|camo green|camouflage grun|vert camouflage|jungle camo|green tiger camo|tiger camo|midnight camo
#6E7A4E moss|mos|moos|mousse|moss green|mosgroen|moosgrun|vert mousse
#84CC16 lime|limoen|limette|citron vert|lime green|limegroen|lime groen|limettengrun|limoengroen|limegrun|vert citron|vert lime|acid green|lime tree green|lindengrun
#A4D233 lively lime|vert citron vif
#8DB600 apple green|appelgroen|appel groen|apfelgrun|vert pomme
#93C572 pistachio|pistache|pistazie|vert pistache
#5A9A3E leaf|blad|blatt|feuille|leaf green|blattgrun|vert feuille|bladgroen
#6BBF59 spring green|lentegroen|fruhlingsgrun|vert printemps
#2E8B57 sea green|zeegroen|meergrun|vert mer
#3A9D7A ocean green|oceaangroen|ozeangrun|vert ocean
#3CC8B4 aqua green|aquagrun|vert aqua
#39FF14 neon green|neongroen|neon groen|neongrun|fluo green|fluo groen|vert fluo|fluorescent green|vert fluorescent|fluoreszierendes grun|vert neon|day glow green|vert day glow
#317F43 signal green|signaal groen|signaalgroen|signalgrun|vert signal
#B5E61D safety green|veiligheidsgroen|sicherheitsgrun|vert de securite
#B7E4B0 pastel green|pastelgroen|pastel groen|pastellgrun|vert pastel
#2E6B4F alpine green|alpengrun|vert alpin
#3B5E3A ivy|klimop|efeu|lierre|ivy green|efeugrun|vert lierre
#2A5D3A jungle|dschungel
#355E3B hunter green|jagersgroen|jagergrun|vert chasseur
#4F7942 beetle green|kafergrun|vert scarabee
#6B8E4E rosin green|kolophoniumgrun|vert colophane
#6E9F4A stem green|stielgrun|vert tige
#3C8D2F real green|echt grun|vert realiste|realistisch groen
#4CAF50 go green|grun werden
#3BA55D jolly green|frohliches grun|vert joyeux
#74A089 glazed green|glasiertes grun|vert glace|vert glazed
#3FA34D gumdrop green|gumdrop grun
#8FBF9F aloe|vert aloe
#B5C99A orchid green|orchidee groen|orchideengrun|orchidee grun|vert orchidee
#8BA888 dusty green
#2F6F4E green bay|vert green bay
#2D5D50 marine green
#A8D5BA light jade|helles jade|jade clair
#7FB5A1 jade|misty jade|nebliges jade|jade brumeux
#5B9E8F jade dome|jadekuppel|dome de jade
#3E5F5A blue spruce|spruce|fichte|epicea
#545D3A cypress|zypresse|cypres
#B7C3A7 bay
#2563EB blue|blauw|blauwe|blau|blaue|blauer|bleu|bleue|blu|azul|true blue|echt blauw
#93C5FD light blue|lichtblauw|licht blauw|hellblau|bleu clair|light blue metallic
#A7C7E7 baby blue|babyblauw|baby blauw|babyblau|bleu bebe|bleu baby|babyblue
#87CEEB sky|sky blue|hemelsblauw|himmelblau|bleu ciel|lucht|lucht blauw|ciel|pure sky|reines himmelblau|bleu ciel pur|skyway blue|skyway blau|bleu celeste
#B0D4E8 powder blue|poederblauw|puderblau|bleu poudre
#1E3A8A dark blue|donkerblauw|donker blauw|dunkelblau|bleu fonce|textile dark blue|textiel donkerblauw|textil dunkelblau|textile bleu fonce|heather dark blue|dunkelblau meliert
#1F2A44 navy|navy blue|marine|marineblauw|marine blauw|marineblau|bleu marine|navy blau|blau marine|heather navy|navy meliert|marine meliert|marineblau meliert|bleu marine chine
#1B2340 french navy|oxford navy|dark navy|dunkelmarine|deep navy|tiefes marineblau|bleu marine profond|navy pure|reines marine|bleu marine pur|marineblazer|navy blazer|bleu marine blazer|bleu marine fonce
#2A3346 midnight|middernacht|mitternacht|minuit
#14213D night blue|nachtblauw|nachtblau|bleu nuit
#2251B5 royal|royal blue|koningsblauw|konigsblau|koningsblau|bleu roi|royaal blauw|royal blauw|king blue|true royal|vrai royal|team royal|bleu royal equipe|bright royal|heather royal|heather true royal|heather royal blue|konigsblau meliert|bleu roi chine|chine vrai royal|echt royal|true royal triblend
#0047AB cobalt|kobalt|cobalt blue|kobaltblauw|kobaltblau|kobalt blau|kobalt blue|bleu cobalt|colbalt blue
#2E5BFF electric blue|elektrisch blauw|bleu electrique
#001489 reflex blue|reflex blauw|reflexblau|bleu reflex
#0F52BA sapphire|saffier|saphir|sapphire blue|saffier blauw|saphirblau|bleu saphir|heather sapphire|saphir meliert|bleu saphir chine
#1F5C8A antique sapphire|antiker saphir|antik saphir|saphir antique
#3A4D7A indigo|indigo blue|indigoblau|bleu indigo|indigo denim|indigo demin
#3A8FD9 azure|azuur|azurblau|bleu azur|azure blue
#6495ED cornflower|korenbloem|kornblumenblau|bleu bleuet|cornflower blue
#7BAFD4 carolina blue|carolina blau|bleu caroline
#6D8BA6 stone blue|steinblau|bleu pierre
#5D7A9A denim|jeans|blue jean|blue jeans|bleu denim|spijkerblauw
#8FA9C4 light denim|light washed denim|denim clair|hellgewassen denim|denim delave clair|classic light denim
#6F86A2 washed denim|denim delave|gewaschen denim
#4E6A8E classic denim|klassisches denim|denim classique
#A9BCD0 chambray
#BBD3DF ice blue|ijsblauw|eisblau|bleu glace|blue ice
#6E8FD5 flo blue
#7CC0D3 lagoon blue|lagunenblau|bleu lagon|lagoon
#3E5E8F mystic blue
#1F6FA8 ocean blue|oceaanblauw|ozeanblau|bleu ocean
#1E3C5A ocean depth|ozeantiefe|ocean profond|bleu ocean profond
#3B6E99 lake blue|seenblau|bleu lac
#36A4C9 pool blue|poolblau|bleu piscine
#2E7DAF surf blue|surf blauw|surfblau|bleu surf|heather surf|surf meliert|surf chine|surf the web blue|bleu surf the web
#3AB0D8 hawaiian blue|hawaii blau|bleu hawaien
#1CA3C6 tropical blue|tropisches blau|bleu tropical
#16A9C5 caribbean blue|carribean blue|karibikblau|bleu caraibes|bleu des caraibes
#2C7FA4 pacific|pazifik|pacifique|pacific breeze|pacific breeze blau
#2A5379 nordic blue|nordisches blau|bleu nordique
#5D8AA8 airforce blue|air force blue|airforce blau|bleu air force
#1C5A6B petrol|petrolblau|bleu petrole|petroleum blue|petrolblauw
#2D4A86 metro blue|metro bleu
#1F3B73 skipper blue|skipperblau
#2D4E83 worker blue|arbeiterblau|arbeiter blau|bleu de travail
#4A79B5 lotus blue|lotusblau|bleu lotus
#7EA4C9 serene blue|ruhiges blau|bleu serein|bleu paisible
#6C8EB6 mindful blue|achtsames blau|bleu mindful
#7D9CB4 dusty blue
#5B6E8C blue dusk|bleu crepuscule|dusk|crepuscule|dammerung|schemering
#A5B5C4 blue fog|blauer nebel|bleu brume
#3C6FB6 mid blue|middenblauw|mittelblau|bleu moyen
#1E6FE8 bright blue|helderblauw|bleu vif|leuchtendes blau
#5C7FA3 hale blue|hale blauw|hale blau
#22D3EE aqua|aqua blue|aqua blau|bleu aqua|eau|heather aqua|chine aqua|aqua triblend|triblend aqua
#6FD6C8 aquamarine|aquamarijn|aquamarin|aigue marine
#00AEEF cyan|cyaan|cyanblau
#30C5C5 turquoise|turkoois|turqoise|turkis|turkise|turquoise blue|turkisblau|very turquoise|intensives turkis|turquoise vif|turchese|turquesa
#00808A teal|sarcelle|bleu canard|teal blue|eendblauw|petrolgroen|heather deep teal|deep teal|teal triblend|triblend bleu canard|chine bleu sarcelle fonce
#1E7A72 teal monstera|turkise monstera|bleu sarcelle monstera
#4FA3A5 amalfi teal|bleu sarcelle amalfi
#9CD8CB island reef|recif insulaire
#8FCFB9 seafoam|zeeschuim|meerschaum|ecume de mer
#7C3AED purple|paars|paarse|purper|purpur|pourpre|viola|morado|roxo
#7F3FBF violet|violett|violetta
#4B1F6F dark purple|donkerpaars|dunkelviolett|dunkellila|violet fonce|deep purple
#B9A1D9 light purple|lichtpaars|hellviolett|violet clair|helles lila
#C8A2C8 lilac|lila|lilas|flieder|lilla|lila meliert|chine prism lilas|heather prism lilac
#C48AE0 bright lilac|helder lila|lilas eclatant
#B9A3E3 lavender|lavendel|lavande
#D3C4EC soft lavender|zachte lavendel|sanfter lavendel|lavande douce
#B784A7 mauve|malve|malven|mauve triblend|malven triblend|triblend mauve|heather mauve|mauve bruyere
#6C3461 plum|pruim|pflaume|prune
#4E2340 deep plum|prune profonde|tiefe pflaume
#5B3E73 grape|druif|druiven|traube|raisin|grape jelly|grape jelly violett
#C9A3CF orchid|orchidee|orchidée
#8E3FBF radiant purple|strahlendes lila|violet eclatant
#8A2D8C passion violet
#7B3FA0 purple love|lila liebe
#4B2E83 team purple|violet equipe
#9B6FB5 royal lilac|konigsflieder|lilas royal
#C8B6DB millennial lilac|millennial flieder|lilas millenial|lilas millennial
#4B2C3E aubergine
#5A4FCF iris
#D9017A magenta|magenta rosa|magenta pink|rose magenta
#E0218A fuchsia|fuchsie|fuchsia rose|fuchsie rosa|textile fuchsia|textil fuchsia
#D11F7A festival fuchsia
#DB3E79 heliconia|helikonie
#F472B6 pink|roze|rosa|rose|roos|rosado|rose pur|uni roze mix|solid pink blend|melange rose uni
#F9C6D3 light pink|lichtroze|hellrosa|helles rosa|rose clair|pale pink|blassrosa|rose pale|soft pink|zachtroze|zacht roze|zartrosa|rose tendre|rose doux|sanftes rose|baby pink|babyroze|baby roze|babyrosa|rose bebe|pastel pink|pastelroze|pastellrosa|rose pastel
#FF3E9A hot pink|knalroze|rose vif|bright pink|helder roze|leuchtendes pink|kraftiges pink|rose eclatant|warm pink
#FF2E93 neon pink|neonroze|neon roze|neonrosa|neonpink|fluo pink|fluo roze|rose fluo|fluorescent pink|rose fluorescent|rose neon|fluoreszierendes pink|flurozierendes rosa|day glow pink
#F07AAE azalea|azalee|azalée
#C08081 old pink|oud roze|altrosa|vieux rose|dusty rose|dusky pink|dusty pink
#F1C6CB powder pink|poeder roze|puderrosa|rose poudre|rose poudree|powder rose|puderrose
#F4C2C2 blush|blush pink|rose blush
#E8C9C0 blush mint|menthe blush
#F7A1C4 candy pink|bonbonrosa|rose bonbon|snoeproze
#FFA6C9 bubblegum|bubble pink|rose bulle|kauwgomroze
#F3C2CF cotton pink|baumwollrosa|rose coton
#E95C8C cherry pink|kirschrosa|rose cerise
#F2A2C0 classic pink|klassiek roze|klassisches rosa|klassisches pink|rose classique
#F18EAA warm roze
#E9A39A canyon pink|canyon rosa|rose canyon|canyon rose
#F2C4D3 blossom|bloesem|blute|fleur|bluete
#E28FB8 orchid pink|orchideenrosa|rose orchidee
#E7B3C3 hazy pink
#EB5F9C true pink|echtes pink
#F7A1B5 pink lemonade|pinke limonade
#F4799D pink fizz|rose petillant
#F06292 pink joy|rosa freude|rose joie|rose joyeux
#F58FB2 fresh pink|frisches rosa|rose frais
#EBC1C4 soft rose
#E3BC9A nude|huidkleur|hautfarbe
#8B5A2B brown|bruin|bruine|braun|braune|brauner|brun|brune|marrone|marron|castanho
#B5835A light brown|lichtbruin|licht bruin|hellbraun|brun clair
#5C3A21 dark brown|donkerbruin|donker bruin|dunkelbraun|brun fonce|marron fonce
#5D3A1A chocolate|chocolade|schokolade|chocolat|choco
#3D2314 dark chocolate|pure chocolade|zartbitter|zartbitterschokolade|dunkle schokolade|chocolat noir
#4A3B32 espresso
#6F4E37 mocha|mokka|moka|mocca
#4A3428 dark mocha|dark mocca|dunkler mokka|moka fonce
#6B4A3A cocoa|cacao|kakao|cocoa brown|kakaobraun|brun cacao
#5B3A29 coffee|koffie|kaffee|cafe|roasted coffee|rostkaffee|cafe torrefie
#8C6B4F cappuccino|cappuccino brown|cappuccinobraun|brun cappuccino
#C8A27C latte|caffe latte|cafe latte|beige latte|milchkaffee
#AF6E3D caramel|karamel|karamell
#C19A6B camel|kameel|kamel|camel brown|kameelbruin|kamelbraun|brun chamel|fauve
#D2B48C tan|lichtbruin beige
#D8C7A3 sand|zand|sable|sabbia|zandkleur|sandfarben
#D8CCB9 sandshell|coquille de sable
#D6C3A5 beige
#8B7D6B taupe|warm taupe|warmtaupe|taupe chaud
#7B3F00 chestnut|kastanje|kastanie|chataigne|kastanienbraun|marron chataigne
#6A2E1F mahogany|mahonie|mahagoni|acajou
#5D432C walnut|walnoot|walnuss|noyer
#B48A57 oak|eik|eiken|eiche|eichen|chene
#A0703F teak|teck|teakholz
#D9B47E pine|dennenhout|grenen|kiefernholz|fichtenholz|bois de pin|pine wood|grenenhout|pencil wood|houten potlood|holz bleistift|crayon en bois naturel
#A47149 wood|hout|holz|bois|wooden|houten|holzoptik|houtlook|wood look|aspect bois
#2B2118 ebony|ebbenhout|ebenholz|ebene
#5B2C1A palisander|palissander|palissandre|palisanderholz
#7A3B3B rosewood|rose wood|rosenholz|bois de rose
#C49A6C kraft|kraftpapier|kraft brun|kraft paper|kraftpapier eco|speckletone kraft|braun kraftpapier
#8D8A72 hemp|hennep|hanf|chanvre
#C9A97E desert|woestijn|wuste|desert braun|brun desert
#D4BFA0 desert dust|wustenstaub|poussiere du desert
#7B5B45 falcon brown|falkenbraun|brun faucon
#6E4B3A heritage brown|heritage braun|brun heritage
#A8875E savanna|savana|savanne|savane|brown savanna|brown savana|braune savanne|brun savane
#B07D62 clay|klei|ton|argile|heather clay|chine argile|clay triblend|ton triblend|triblend argile
#E5D2B3 biscuit|keks|biscuit beige
#EADBC8 almond|amandel|mandel|amande
#D8CCB4 oatmeal|havermout|avoine|oatmeal heather|oatmeal meliert|avoine chine|heather oatmeal
#C2A878 rope|touw|seil|corde
#B9A98B mastic|mastix
#DDD3C3 oyster|oester|austern|huitre
#D7C6B5 dust|stof|staub|poussiere|heather dust|chine poussiere
#A39B85 prairie dust|poussiere de prairie
#B5895B cork|kurk|kork|liege
#F0EAD6 pearl|parel|parelmoer|perlmutt|perlmut|perle|nacre|parelwit|metallic pearl|metallic perle|perle metallisee
#E8E6E1 marble|marmer|marmor|marbre
#C7CCD1 oxford|light oxford|hell oxford|oxford clair|oxford grey
#8EE53F kiwi
#8FAE9A eucalyptus|faded eucalyptus|verblasstes eukalyptus|eucalyptus delave|eukalyptus
#C26A2E autumn|herbst|automne|herfst
#1EA6A8 atoll|atol
#2DA5B5 aquatic|aquatisch|aquatique
#2E5E6E stargazer
#F2A541 nispero|loquat|mispel
#A7B2AE mineral|mineraal
#8A8478 tweed
#F6A2A8 sorbet
#9A97A8 wild pigeon|wildtaube|pigeon sauvage|duif|taube
#001489 reflex|reflexion
#4682B4 steel blue|bleu acier|stahlblau|staalblauw
#36454F charcoal gray|kohlegrau|gris charbon
#4A4D50 carbon grey|carbon gray|gris carbone|carbongrau|carbon
#2D5A3D pine green|vert pin|vert sapin|kieferngrun|dennengroen|tannengrun|sapin
#1F4D36 evergreen|immergrun|vert persistant
#9C7FA8 dusty purple
#CC5500 burnt orange|orange brule|verbranntes orange|brennendes orange|gebrand oranje
#E7B616 mustard yellow|senfgelb|jaune moutarde|mosterdgeel
#733635 garnet red|granatrot
#5D7A9A denim blue|denimblau|jean bleu
#6E8FD5 bleu flo
#3E5E8F bleu mystique
#3AB0D8 tahiti blue|tahiti blau|bleu tahiti
#3E5F5A epinette bleue
#2F6F4E vert baie
#556B2F olijf groen
#0047AB kobalt blauw
#4B5D3A green camo|camouflage vert|gruner camo
#1B2340 bleu marine oxford|midnight navy|mitternachtsmarineblau|bleu marine nuit|heather midnight navy
`;

function parseNames(source: string): Record<string, string> {
  const table: Record<string, string> = {};
  for (const line of source.split('\n')) {
    const trimmed = line.trim();
    if (!trimmed) continue;
    const space = trimmed.indexOf(' ');
    const hex = trimmed.slice(0, space).toUpperCase();
    for (const name of trimmed.slice(space + 1).split('|')) {
      const key = name.trim();
      if (key && !(key in table)) table[key] = hex;
    }
  }
  return table;
}

export const COLOR_NAMES: Record<string, string> = parseNames(NAME_SOURCE);

/** Namen die een metallic glans hebben (verloop in plaats van vlakke kleur). */
export const METALLIC_NAMES = new Set([
  'silver', 'zilver', 'silber', 'argent', 'argente', 'argento', 'prata', 'zilverkleurig', 'silberfarben', 'silver coloured',
  'aluminium', 'aluminum', 'alu', 'alimunium', 'aluminium silber', 'aluminium argent', 'zilver aluminium', 'silver aluminium',
  'inox', 'rvs', 'stainless steel', 'edelstahl', 'edelstahl rostfrei', 'roestvrij staal', 'chrome', 'chroom', 'chrom',
  'metal', 'metaal', 'metall', 'metale', 'nickel', 'nikkel', 'matt silver', 'mat zilver', 'silber matt', 'argent mat',
  'platinum', 'platina', 'platin', 'platine',
  'gold', 'goud', 'or', 'dore', 'oro', 'ouro', 'goudkleurig', 'goldfarben', 'gold coloured', 'old gold', 'altgold', 'vieux or', 'oud goud',
  'vegas gold', 'or vegas',
  'rose gold', 'rosegold', 'rosegoud', 'or rose', 'rotgold',
  'copper', 'koper', 'kupfer', 'cuivre', 'rame',
  'bronze', 'brons', 'bronzo',
]);

/** "Geen"-waarden: krijgen een doorgestreepte staal en tellen als opgelost. */
export const NONE_PREFIXES = [
  'geen', 'none', 'no', 'aucun', 'aucune', 'sans', 'ohne', 'kein', 'keine', 'keinen', 'pas de', 'pas d',
  'nessuno', 'ninguno', 'niet van toepassing', 'n v t', 'nvt', 'not applicable', 'ne s applique pas', 'without', 'zonder',
];

export const TRANSPARENT_WORDS = [
  'transparent', 'transparant', 'transparente', 'transparentes', 'clear', 'doorzichtig', 'klar', 'kristalhelder', 'kristallklar',
  'crystal clear', 'cristal', 'helder transparant', 'semi transparant', 'semi transparent',
];

export const FROSTED_WORDS = [
  'frosted', 'mat glas', 'matglas', 'melkglas', 'milchglas', 'melkglasfolie', 'milchglasfolie', 'givre', 'sandblast', 'zandstraal',
  'zandstraalfolie', 'sandstrahlfolie', 'film sable', 'film depoli', 'mattiert',
];

export const MULTI_WORDS = [
  'multicolour', 'multicolor', 'multicolore', 'meerdere kleuren', 'mehrfarbig', 'kleurenmix', 'farbmix', 'colour mix', 'color mix',
  'melange de couleurs', 'rainbow', 'regenboog', 'regenbogen', 'arc en ciel', 'bont', 'gemengd',
];

export const MODIFIERS: Record<string, 'dark' | 'light' | 'soft' | 'neon' | 'bright' | 'metallic' | 'heather'> = {
  donker: 'dark', donkere: 'dark', dunkel: 'dark', dunkle: 'dark', dunkles: 'dark', dunkler: 'dark', dark: 'dark', fonce: 'dark', foncee: 'dark',
  deep: 'dark', diep: 'dark', tief: 'dark', tiefes: 'dark', profond: 'dark', profonde: 'dark', scuro: 'dark', oscuro: 'dark',
  licht: 'light', lichte: 'light', hell: 'light', helle: 'light', helles: 'light', heller: 'light', light: 'light', clair: 'light', claire: 'light',
  pale: 'light', bleek: 'light', blass: 'light', chiaro: 'light', claro: 'light',
  zacht: 'soft', zachte: 'soft', zart: 'soft', zarte: 'soft', soft: 'soft', doux: 'soft', douce: 'soft', pastel: 'soft', pastell: 'soft', baby: 'soft',
  neon: 'neon', fluo: 'neon', fluor: 'neon', fluorescent: 'neon', fluoreszierend: 'neon', fluoreszierendes: 'neon',
  bright: 'bright', helder: 'bright', knal: 'bright', leuchtend: 'bright', leuchtendes: 'bright', vif: 'bright', vive: 'bright', intens: 'bright',
  metallic: 'metallic', metallisch: 'metallic', metallise: 'metallic', metallisee: 'metallic', metallique: 'metallic', metalic: 'metallic', metalllic: 'metallic',
  melange: 'heather', meliert: 'heather', gemeleerd: 'heather', chine: 'heather', heather: 'heather', mele: 'heather',
};

/** Verbindingswoorden voor tweekleurige waarden: "zwart met wit", "black and gold". */
export const CONNECTORS = new Set(['and', 'en', 'met', 'und', 'mit', 'et', 'with', 'avec', 'e', 'y']);
